// src/pages/BrandingPage.js

import React, { useState, useEffect } from 'react';
import { Container, Box, TextField, Button, Typography } from '@mui/material';

const textFieldStyles = {
  '& .MuiFormLabel-root': {
    color: '#fff',
  },
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    '& fieldset': {
      borderColor: '#fff',
    },
    '&:hover fieldset': {
      borderColor: '#fff',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#fff',
    },
  },
};

const BrandingPage = () => {
  const [logoUrl, setLogoUrl] = useState('');
  const [colorScheme, setColorScheme] = useState('#1976d2'); // Default primary color
  const [footerText, setFooterText] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const branding = JSON.parse(localStorage.getItem('brandingSettings'));
    if (branding) {
      setLogoUrl(branding.logoUrl || '');
      setColorScheme(branding.colorScheme || '#1976d2');
      setFooterText(branding.footerText || '');
    }
  }, []);

  const handleSave = () => {
    const settings = { logoUrl, colorScheme, footerText };
    localStorage.setItem('brandingSettings', JSON.stringify(settings));
    setMessage('Branding settings saved successfully.');
  };

  return (
    <Container
      sx={{
        mt: 4,
        backgroundColor: '#000',
        color: '#fff',
        p: 2,
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ color: '#fff' }}>
        Branding Settings
      </Typography>
      <Box sx={{ mt: 2 }}>
        <TextField
          label="Logo URL"
          fullWidth
          margin="normal"
          value={logoUrl}
          onChange={(e) => setLogoUrl(e.target.value)}
          sx={textFieldStyles}
        />
        <TextField
          label="Primary Color"
          fullWidth
          margin="normal"
          type="color"
          value={colorScheme}
          onChange={(e) => setColorScheme(e.target.value)}
          sx={textFieldStyles}
          // For color inputs, the text won't show in the field itself,
          // but this ensures the label and outline are white.
        />
        <TextField
          label="Footer Text"
          fullWidth
          margin="normal"
          value={footerText}
          onChange={(e) => setFooterText(e.target.value)}
          sx={textFieldStyles}
        />
        <Button variant="contained" color="primary" onClick={handleSave} sx={{ mt: 2 }}>
          Save Branding
        </Button>
        {message && (
          <Typography color="primary" sx={{ mt: 2 }}>
            {message}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default BrandingPage;
